<template>
  <div class="status" :class="StateTexteBG">
    {{ StateTexte }}
  </div>
</template>

<script>
import { dockStateColorText } from "@/utils/Utils.js";

export default {
  props: {
    config: Object
  },
  computed: {
    StateTexte() {
      let mode_code = this.config?.dock?.status?.mode_code != undefined
        ? this.config.dock?.status.mode_code
        : ENV.NO_DATA;

      return this.$root.status_dock.hasOwnProperty(mode_code)
        ? this.$root.status_dock[mode_code]
        : mode_code;
    },

    StateTexteBG() {
      let mode_code = this.config?.dock?.status?.mode_code != undefined
        ? this.config.dock?.status.mode_code
        : ENV.NO_DATA;

      let LastPing = this.config?.dock?.status?.LastPing != undefined
        ? parseInt(this.config.dock?.status.LastPing)
        : 0;

      return dockStateColorText(mode_code, LastPing);
    },
  },
};
</script>
